import { Fade, Paper } from "@mui/material";
import { FC } from "react";

export const DialogFader: FC = () => {
  return (
    <Fade in={true} timeout={0}>
      <Paper variant="fade"></Paper>
    </Fade>
  );
};
